var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parking"},[_c('parking-amap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }